import { FC } from 'react';
import { Box } from '@mui/material';
import cn from 'classnames';

import CardWithShadow from '@components/CardWithShadow/CardWithShadow';

import { IEmptyCardProps } from './EmptyCard.interface';

import './style.scss';

const EmptyCard: FC<IEmptyCardProps> = ({ className, icon, description, borderType = 'solid' }) => (
  <CardWithShadow className={cn('empty-card', className)} borderType={borderType}>
    {icon && (
      <Box className="empty-card__icon">
        <Box component="img" src={icon} />
      </Box>
    )}

    <Box className="empty-card__description">
      <p className="subtitle-big">{description}</p>
    </Box>
  </CardWithShadow>
);

export default EmptyCard;
